/** Extrait le nom de fichier de l'en-tête `Content-Disposition`, sinon retourne `fallback`. */
export const getFileName = (response: Response, fallback: string): string => {
  const header = response.headers.get('Content-Disposition') ?? '';
  const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.trim());
    } catch {
      // Valeur mal encodée : on se rabat sur `filename`.
    }
  }
  const plain = /filename\s*=\s*(?:"([^"]+)"|([^;]+))/i.exec(header);
  return (plain?.[1] ?? plain?.[2])?.trim() || fallback;
};

/** Enregistre un fichier reçu en mémoire via un lien de téléchargement temporaire. */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
